module.exports = __webpack_public_path__ + "static/media/elan.bef17d6d.png";